import script from "./TaskRunner.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskRunner.vue?vue&type=script&setup=true&lang=js"

import "./TaskRunner.vue?vue&type=style&index=0&id=076da22c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076da22c"]])

export default __exports__